// API name constant
export const API_PATH = {
    COMPANIES: 'companies',
    COMPANY: 'company',
    MY_COMPANY: 'me',
    CAMPAIGNS: 'campaigns',
    CAMPAIGN: 'campaign',
    IMAGE: 'image',
    ENGAGEMENT: 'engagement',
    WEB_MATRIX: 'webMatrix',
    DIGITAL: 'digital',
    FIELD: 'field',
    MESSAGES: 'messages',
    PRESCRIBERS: 'prescribers',
    TOP_PRESCRIBERS: 'topPrescibers',
    SUMMARY: 'summary',
    TRIGGERS: 'triggers',
    TOTAL: 'total',
    EXPORT: 'export',
    INGESTION: 'ingestion',
    PRESCRIPTION: 'prescription',
    PERFORMANCE: 'performance',
    PROFILE: 'profile',
    USER: 'user',
    ME: 'me',
    IMAGE: 'image',
    TRIGGER_FIELDS: 'triggerFields',
    STORE_TRIGGER_FIELDS_MAP: 'storeTriggerFieldsMap',
    STORE_TRIGGER_FIELDS: 'storeTriggerFields',
    COIEFV: 'coiefv',
    SETTINGS: 'settings',
    TRIGGER_PAGINATE: 'triggersPaginate',
    TRIGGER_Multiple_PAGINATE: 'triggersMultiplePaginate',
    TRIGGER_Multiple_GRAPH_DATA: 'triggersMultipleGraphData',
    PARTNERS: 'partners',
    PARTNER: 'partner',
    CHANNELS: 'channels',
    CHANNEL: 'channel',
    FIELD_VALUE: 'field-value',
    TYPE_FIELD_MAPPING: 'type-field-mapping',
    CHANNEL_TYPES: 'channel-types',
    ALL: 'all',
    CHANNEL_TYPE_TEMPLATES: 'channel-type-templates',
    SELECTED: 'selected',
    API: 'api',
    CUSTOMERS: 'customers',
    EDIT: 'edit',
    DEDUPLICATION: 'deduplication',
    SLAESFORCE: 'salesforce',
    OAUTH2: 'oauth2',
    AUTORIZE: 'authorize',
    OCE: 'oce',
    CONNECTIONS: 'connections',
    DELETE: 'delete',
    DATAINPUTS: 'datainputs',
    PREVIEW: 'preview',
    SMS: 'sms',
    ECHOS: 'echos',
    BANNER: 'banner',
    EMAIL: 'email',
    REP: 'rep',
    MEDIA: 'media',
    DURATIONS: 'durations',
    DATASOURCES: 'datasources',
    LOGS: 'logs',
    PAGEQUERY: '?page=',
    IMPORTANCE: 'importance',
    TARGETLIST: 'targetlist',
    INTENSITY: 'intensity',
    PHYSICIANS: 'physicians',
    PHYSICIAN: 'physician',
    POSITIONQUERY: '?position=',
    HCPPROFILEDATA: 'gethcpprofiledata',
    COUNT: 'count',
    LOGOUT: 'logout',
    ANALYSIS_REPORT: 'analysis-report',
    YEARS_OF_EXPERIENCE: 'years-of-experience',
    SPECIALTIES_DATA: 'specialties-data',
    TOP_STATES_BY_INDIVIDUALS: 'top-states-by-individuals',
    DIGITAL_VS_NON_DIG_AFFINITY: 'digital-vs-non-digital-affinity',
    PASSWORD: 'password',
    UPLOAD: 'upload',
    AFFINITY_BY_SEGMENT: 'affinity-by-segment',
    AFFINITY_REPORT: 'affinity-report',
    PEER_PEER_AFFINITY_DATA: 'peer-peer-affinity-data',
    PERSONAL_PROMOTION_CHANNEL_AFFINITY: 'personal-promotion-channel-affinity',
    DYNAMIC_TOPIC_COUNTS: 'dynamic-topic-counts',
    BRANDED_UNBRANDED_COUNTS: 'branded-unbranded-counts',
    DISTRIBUTION_EXPERIENCE: 'distribution-experience',
    REGION_COUNT: 'region-count',
    CALCULATE_SCORE: 'calculate-score',
    DIGITAL_CHANNEL_AFFINITY: 'digital-channel-affinity',
    CONTENT_AFFINITY_KEYWORDS: 'content-affinity-keywords',
    CONTENT_KEYWORDS: 'content-keywords',
    VENDOR_AFFINITY: 'vendor-affinity',
    GET_TOTAL_PHYSICIANS: 'get-total-physicians',
    MARKETOAUTH: 'marketoAuth',
    TESTAUTH: 'testAuth',
    TOP_ENGAGERS: 'top_engagers',
    REGION_EXTENDED: 'region_extended',
    SEGMENT_EXTENDED: 'segment_extended',
    ACTIVITY: 'activity',
    TRIGGERS_FTM: 'triggersFtm',
    ALL_ENGAGERS: 'all_engagers',
    EXECUTIVE_SUMMARY_DOCUMENT: 'executive-summary-document',
    COMPANY_CAMPAIGN_TYPE_ACTIONS: 'company-campaign-type-actions',
    CACHE: 'cache',
    LIST: 'list',
    CLEAN: 'clean',
    PROFILES: 'profiles',
    QUALITY_VISITS: 'qualityVisits',
    WEB_MATRIX_PATIENT: 'webMatrixPatient',
    TOP_WEBSITES: 'topWebsites',
    WEB_MATRIX_PATIENT_COUNT: 'webMatrixPatientCount',
    CREATIVE_UPLOAD: 'creative-upload',
    CREATIVE_BY_ID: 'creativeById',
    WEB_MATRIX_PATIENT_ANALYSIS_SUMMARY: 'webMatrixPatientAnalysisSummary',
    PAID_SEARCH_SUMMARY_ANALYSIS: 'paidSearchSummaryAnalysis',
    PAGE_SIZE_QUERY: 'page_size=',
    WEB_MATRIX_COST: 'webMatrixCost',
    ENGAGEMENT_RATE: 'engagementRate',
    WEB_MATRIX_GEOGRAPHY: 'webMatrixGeography',
    WEB_MATRIX_MULTI_USAGE: 'webMatrixMultiUsage',
    CONFIG: 'config',
    TAG: 'tag',
    CLEAR_ALL_BATCH: 'clear-all-batch'
};

export const API_VERSION = 'api/v1';
